<template>
    <div
        component="TableRow"
        v-click-outside="hideAll"
        @click="showDetail"
        :id="row.id"
        :no-mouse="!clickable && !draggable"
        :class="{ selected: isSelected, editing: editing }"
    >
        <!-- {{row}} -->
        <!-- {{config}} -->
        <table-cell v-for="(value, key, index) in row" :key="key" :cell="config[index]">
            <template v-if="config[index].type == 'text' && !!!config[index].editable">
                {{ value }}
            </template>
            <template v-if="config[index].type == 'text' && !!config[index].editable">
                <table-cell-text-editor
                    :value="value"
                    :kluc="key"
                    :row="row"
                    @editing="setEdited"
                    @save="save"
                    :selected="isSelected"
                    :isEditing="editing"
                />
            </template>
            <template v-if="config[index].type == 'player'">
                <mp3-player :file="row.url" :visualizer="config[index].visualizer" tpos="none" />
            </template>
        </table-cell>
        <button
            v-if="removable"
            class="button-close"
            size="icon"
            color="transparent"
            @click.prevent.stop="showRemoveConfirm"
        >
            <i class="icon">close</i>
        </button>
        <transition name="show">
            <div v-if="deleting" class="warning">
                <div class="question">Remove file?</div>
                <div class="buttons">
                    <btn
                        :icon="'close'"
                        t-pos="none"
                        radius="circle"
                        color="ghost"
                        for-background="dark"
                        @click.prevent.stop="hideRemoveConfirm"
                    />
                    <btn
                        :icon="'done'"
                        t-pos="none"
                        radius="circle"
                        color="ghost"
                        for-background="dark"
                        @click.prevent.stop="removeItem"
                    />
                </div>
            </div>
        </transition>
        <!-- <div v-for="(value, key, index) in row">
		  {{ index }}. {{ key }}: {{ value }},
		   {{config[index]}}
		</div> -->
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import TableCell from '@/components/.global/ScrollTable/TableCell.vue';
import TableCellTextEditor from '@/components/.global/ScrollTable/TableCellTextEditor.vue';
import Mp3Player from '@/components/.global/Mp3Player.vue';
import ClickOutside from 'vue-click-outside';

export default {
    name: 'TableRow',

    props: {
        draggable: {
            type: Boolean,
            default: false,
        },

        hasDetail: {
            type: Boolean,
            required: false,
            default: false,
        },

        row: {
            type: Object,
            required: true,
        },

        config: {
            type: Array,
            required: true,
        },

        clickable: {
            type: Boolean,

            required: false,
            default: false,
        },

        removable: {
            type: Boolean,
            required: false,
            default: false,
        },

        selected: {
            // type: String,
            required: false,
            // default: false,
        },
    },

    data() {
        return {
            deleting: false,
            editing: false,
        };
    },

    computed: {
        isSelected() {
            return this.row == this.selected;
        },
    },

    methods: {
        hideAll() {
            this.deleting = false;
            this.editing = false;
        },

        setEdited(state) {
            this.editing = state;
        },

        save(row, key, value) {
            this.$emit('save', row, key, value);
        },

        showDetail(event) {
            if (!this.clickable || this.draggable) {
                return;
            }

            this.$emit('select', this.row);

            const row = event.currentTarget;
            this.$router.push({ path: this.$route.path + '/' + row.getAttribute('id') });
        },

        showRemoveConfirm() {
            this.deleting = true;
        },

        hideRemoveConfirm() {
            this.deleting = false;
        },

        removeItem() {
            this.deleting = false;
            this.$emit('remove', this.row);
        },
    },

    components: {
        TableCell,
        TableCellTextEditor,
        Mp3Player,
    },

    directives: {
        ClickOutside,
    },
};
</script>
<style lang="less">
@import '~@variables';

[component='TableRow'] {
    .flex-row;
    border-bottom: 1px solid @grey_lt;
    margin-right: 20px;
    user-select: none;
    cursor: pointer;
    transition: 0s;
    min-height: 30px;
    position: relative;

    &:hover {
        background-color: fade(black, 5%);
    }

    &[no-mouse] {
        pointer-events: none;
        cursor: default;

        button,
        [component='Mp3Player'] {
            pointer-events: all;
        }
    }

    &:hover {
        background-color: none;
    }

    &.selected {
        // background-color: fade(@grey_lt, 100%);
    }

    &.editing {
        .button-close {
            display: none;
        }
    }

    [component='Mp3Player'],
    [component='NavButton'],
    .button,
    button {
        // margin: 0 0 0 5px;
        min-width: 0px;

        i {
            margin: 0;
        }
    }

    [component='Mp3Player'] {
        margin-left: 5px;
    }

    .text-value {
        display: block;
        word-break: break-word;
    }

    .warning {
        position: absolute;
        background-color: @dark;
        color: @white;
        width: 100%;
        height: 100%;
        z-index: 1000;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 8px;
        overflow: hidden;

        .question,
        .buttons {
            transition: 0.3s;
            transition-delay: 0s;
        }

        button {
            font-weight: bold;
            height: 26px;
            width: 26px;

            .icon {
                min-height: 26px;
                min-width: 26px;
                margin: 0 !important;
            }
        }
    }

    .show-enter,
    .show-leave-to {
        opacity: 0;
        position: absolute !important;
        overflow: hidden;

        .question {
            transform: translateX(-100%);
        }

        .buttons {
            transform: translateX(100%);
        }
    }

    .show-enter-active,
    .show-leave-active {
        transition: all 0.5s;
    }

    .show-enter-active {
        transition-delay: 0s;

        .question,
        .buttons {
            transition: 0.5s;
            transition-delay: 0.1s;
        }
    }

    .show-enter-to {
        opacity: 1;
        position: absolute !important;
    }
}
</style>
